import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase-client';

export default function DemoPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [clubName, setClubName] = useState('');
  const [clubType, setClubType] = useState('');
  const [memberCount, setMemberCount] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!name || !email || !clubName) {
      setError('Please fill in your name, email, and club name.');
      return;
    }

    setSubmitting(true);
    try {
      const sendEmail = httpsCallable(functions, 'sendEmail');
      await sendEmail({
        name: name.trim(),
        email: email.trim(),
        clubName: clubName.trim(),
        clubType: clubType.trim(),
        memberCount: memberCount.trim(),
        message: message.trim(),
      });

      setSuccess(true);
      setName('');
      setEmail('');
      setClubName('');
      setClubType('');
      setMemberCount('');
      setMessage('');
    } catch (err) {
      setError(err.message || 'Something went wrong sending your request.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="marketing-root">
      <div className="container py-12 space-y-12">
        <section className="marketing-hero marketing-hero--compact">
          <div className="marketing-orb orb-one" />
          <div className="marketing-orb orb-two" />
          <div className="marketing-hero__layout">
            <div>
              <p className="marketing-kicker">Book a demo</p>
              <h1 className="marketing-heading text-4xl font-bold mb-3">See Member Nest in action.</h1>
              <p className="marketing-lede">
                Tell us a bit about your club and we'll set up a walkthrough tailored to you.
              </p>
            </div>
            <div className="marketing-hero__panel">
              <h3 className="marketing-heading text-2xl font-semibold">What you'll get</h3>
              <div className="marketing-steps">
                {[
                  'A tailored walkthrough of your ideal setup',
                  'A look at events, payments, and member comms',
                  'Time for questions and next steps',
                ].map((text, idx) => (
                  <div key={text} className="marketing-step">
                    <div className="marketing-step__index">{idx + 1}</div>
                    <p className="text-gray-700">{text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="marketing-section">
          <div className="marketing-section__header">
            <h2 className="marketing-heading text-3xl font-semibold mb-2">Request a demo</h2>
            <p className="marketing-lede">
              We'll reply from support@member-nest.com with a few times to choose from.
            </p>
          </div>

          <div className="marketing-grid">
            <div className="marketing-card">
              <form onSubmit={handleSubmit} className="flex-column" style={{ gap: '1rem' }}>
                <input
                  type="text"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="text"
                  placeholder="Club name"
                  value={clubName}
                  onChange={(e) => setClubName(e.target.value)}
                  className="form-input"
                  required
                />
                <input
                  type="text"
                  placeholder="Club type (optional)"
                  value={clubType}
                  onChange={(e) => setClubType(e.target.value)}
                  className="form-input"
                />
                <input
                  type="text"
                  placeholder="Approximate member count (optional)"
                  value={memberCount}
                  onChange={(e) => setMemberCount(e.target.value)}
                  className="form-input"
                />
                <textarea
                  placeholder="Anything specific you want to see?"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="form-input"
                  rows={4}
                />

                <button type="submit" className="button button-primary" disabled={submitting}>
                  {submitting ? 'Sending...' : 'Request demo'}
                </button>

                {error && <p style={{ color: '#b91c1c', margin: 0 }}>{error}</p>}
                {success && <p style={{ color: '#166534', margin: 0 }}>Thanks! We'll be in touch shortly.</p>}
              </form>
            </div>

            <div className="marketing-card">
              <h3 className="text-xl font-semibold mb-3">We keep it simple</h3>
              <ul className="bullet-list">
                <li>No sales pressure</li>
                <li>See the modules that matter to you</li>
                <li>Get setup guidance tailored to your club</li>
              </ul>
              <p className="text-gray-600" style={{ marginTop: '1rem' }}>
                Prefer email? Reach us directly at support@member-nest.com.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
